import { render, staticRenderFns } from "./CompactorRoute.vue?vue&type=template&id=22275019"
import script from "./CompactorRoute.vue?vue&type=script&lang=js"
export * from "./CompactorRoute.vue?vue&type=script&lang=js"
import style0 from "./CompactorRoute.vue?vue&type=style&index=0&id=22275019&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports